/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2025 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
import * as t from "react";
import r from "prop-types";
import { classNames as s } from "@progress/kendo-react-common";
const o = "ActionSheetHeader", e = (a) => /* @__PURE__ */ t.createElement("div", { className: s("k-actionsheet-titlebar", a.className) }, a.children);
e.propTypes = {
  className: r.string
};
e.displayName = o;
e.propTypes = {
  children: r.any
};
export {
  e as ActionSheetHeader,
  o as headerDisplayName
};
